import React from 'react'
import './Home.css'
import './Pages.css'
import BIO from "../assets/bio.json"
import fp from "../assets/FP.png"
import { NavLink } from 'react-router-dom'

export default function Home() {
  return (
    <div>
        <h1 className='text'>janironkainen.com</h1>
        <img className="profilePicture" src={fp} alt=''></img>
        <p>{BIO.content}</p>
        <NavLink className="homeScreenLink" to='/projects'>Projekteihin</NavLink>
    </div>
  )
}
